import { render, staticRenderFns } from "./ProfilePopover.vue?vue&type=template&id=4e4b8b66&"
import script from "./ProfilePopover.vue?vue&type=script&lang=js&"
export * from "./ProfilePopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports